import React from "react";
import { Button, FilterIcon } from "@fluentui/react-northstar";

export interface ShowFiltersButtonProps {
    isActive: boolean;
    onClick: () => void;
}

const ShowFiltersButton: React.FC<ShowFiltersButtonProps> = (props) => {
    return <Button iconOnly icon={<FilterIcon />} onClick={props.onClick} primary={props.isActive} size="small" />;
};

export default ShowFiltersButton;
